import { Link, Navigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Nav } from '@/marketing/blocks/nav';
import { Footer } from '@/marketing/blocks/footer';
import { Section } from '@/marketing/blocks/Section';
import { getPost } from '@/marketing/blog/posts';
import { useCopy } from '@/i18n';

export default function BlogPost() {
  const { slug } = useParams<{ slug: string }>();
  const copy = useCopy();
  const c = copy<{ back: string }>('blog');
  const { i18n } = useTranslation();
  const post = slug ? getPost(slug) : undefined;
  if (!post) return <Navigate to="/blog" replace />;
  const Body = post.Component;
  const dateFmt = new Intl.DateTimeFormat(i18n.language, { dateStyle: 'long' });

  return (
    <>
      <Nav ctaPrimary="" />
      <Section id="blog-post" bg="paper">
        <article style={{ maxWidth: '68ch', margin: '0 auto' }}>
          <Link
            to="/blog"
            style={{ fontSize: 14, color: 'var(--coral)', textDecoration: 'none', fontWeight: 600 }}
          >
            ← {c?.back ?? 'All articles'}
          </Link>
          <h1
            style={{
              fontFamily: 'var(--font-display)',
              fontSize: 'clamp(32px, 5vw, 48px)',
              lineHeight: 1.15,
              marginTop: 18,
              color: 'var(--ink)',
            }}
          >
            {post.title}
          </h1>
          <time
            dateTime={post.date}
            style={{ display: 'block', marginTop: 12, fontSize: 14, color: 'var(--muted)' }}
          >
            {dateFmt.format(new Date(post.date))}
          </time>
          <div className="blog-prose" style={{ marginTop: 32 }}>
            <Body />
          </div>
        </article>
      </Section>
      <Footer />
    </>
  );
}
